import { Injectable } from '@angular/core';
import { SeuEnvApi } from '@seu-types';

@Injectable({
  providedIn: 'root',
})
export class EnvService {
  public setEnv(env: SeuEnvApi): void {
    sessionStorage.setItem('env', env);
  }

  public getEnv(): SeuEnvApi | undefined {
    return sessionStorage.getItem('env') as SeuEnvApi | undefined;
  }
}
